import { userIsNotAuthenticatedRedir } from 'components/auth/hoc';
import { compose } from 'recompose';
import React, { useEffect } from 'react';
import { LandingRecoverForm } from '../components/forms/LandingRecoverForm';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { history } from 'state/store';
import { useSelector } from 'react-redux';
import routes from 'utils/routes';
import authSelectors from 'state/auth/selectors';
import {
  expandHeightAndWidth,
  Flex,
  gridSizes,
  media,
  weights,
} from 'utils/style';

const LandingRecoverComponent = ({ className, match }) => {
  const userIsLogged = useSelector(authSelectors.userIsLogged);

  useEffect(() => {
    if (userIsLogged) {
      history.push(routes.orders.default);
    }
  }, [userIsLogged]);

  if (userIsLogged) return null;

  return (
    <div className={`${className} public-page`} data-testid="login-recover">
      <section className="main" role="main">
        <LandingRecoverForm match={match} />
      </section>
    </div>
  );
};

LandingRecoverComponent.propTypes = {
  className: PropTypes.string,
  t: PropTypes.func,
  match: PropTypes.shape({
    path: PropTypes.string,
  }),
};

LandingRecoverComponent.defaultProps = {
  className: '',
  t: (t) => t,
  match: {},
};

const enhance = compose(userIsNotAuthenticatedRedir);
const StyledLandingRecover = styled(LandingRecoverComponent)`
  ${Flex.column}
  ${expandHeightAndWidth()}
  color: var(--grey700);
  background-color: transparent !important;

  ${media.lessThan('extraSmall')`
    font-size: 14px;
  `};

  .main {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
    padding: 32px;
    ${media.lessThan('extraSmall')`
      padding: ${gridSizes('M')};
    `};
  }

svg {
    margin: 0 0 64px;
    fill: var(--white);

    ${media.lessThan('extraSmall')`
      fill: var(--primary500);
      width: 94px;
      height: 26px;
      align-self: flex-start;
    `};
  }
.info {
    margin: ${gridSizes('M')} 0 0;
    text-align: center;
    &:first-of-type {
      margin: 64px 0 0;
    }
    a {
      color: var(--white);
      font-weight: ${weights('bold')};
      text-decoration: underline;
      font-size: ${gridSizes('M')};
      &:hover {
        filter: invert(8%);
      }
    }

    ${media.lessThan('extraSmall')`
      margin: ${gridSizes('L')} 0 0;
      &:first-of-type {
        margin: 32px 0 0;
      }
      a {
        color: var(--primary500);
        display: block;
        text-align: center;
        font-size: 14px;
        text-decoration: none;
        font-weight: ${weights('regular')};
        &:hover {
          text-decoration: underline;
        }
      }
    `};
  }
`;

const LandingRecover = enhance(StyledLandingRecover);
export { LandingRecover };
